// extracted by mini-css-extract-plugin
export default {"share_url_button":"ShareUrlButton_share_url_button__cnLne"};